import Vue from 'vue';
import DialogVue from './dialog.vue';

let protoDialog = Vue.extend(DialogVue); // 构造函数
let instance; //实例对象

export const Dialog = (options = {}) => {
  if (typeof options === 'string') {
    options = {
      message: options,
    };
  }
  instance = new protoDialog({
    data: options,
  });
  instance.id = `dialog`;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  return instance.vm;
};
